import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { BRAND } from '../../lib/constants';
import { useSiteImage } from '../../lib/useSiteImage';
import { useRegistrationUrl } from '../../lib/useSettings';
import { trackEvent } from '../../lib/analytics';

const FOR_ARTISTS_FALLBACK = 'https://images.unsplash.com/photo-1644134395029-d68dd6b97761?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400';

export const MuaCta = () => {
  const img = useSiteImage('for_artists_main', FOR_ARTISTS_FALLBACK);
  const registrationUrl = useRegistrationUrl();
  return (
    <section className="relative overflow-hidden" data-testid="mua-cta-section">
      <div className="grid lg:grid-cols-12">
        <div className="lg:col-span-7 bg-[#eb5381] text-white p-10 md:p-16 lg:p-24 min-h-[60vh] flex flex-col justify-center">
          <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] opacity-90">
            <Sparkles className="w-4 h-4" /> For Artists
          </div>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight max-w-2xl">
            Get <span className="italic">discovered</span> by brides actively looking to book.
          </h2>
          <p className="mt-7 max-w-xl text-base md:text-lg leading-relaxed text-white/90">
            Join India's most curated beauty marketplace. We send you serious enquiries — not browsers — and shine a spotlight on your portfolio.
          </p>

          <div className="mt-10 inline-block bg-white text-[#eb5381] px-6 py-3 text-[11px] uppercase tracking-[0.25em] w-fit">
            ✦ No Registration Charges For Early Artists
          </div>

          <div className="mt-8">
            <a
              href="/register"
              data-testid="mua-cta-register-btn"
              onClick={() => trackEvent('register_artist_click', { source: 'for_artists_section' })}
              className="inline-flex items-center gap-3 bg-black hover:bg-white hover:text-[#eb5381] text-white px-10 py-4 text-[11px] uppercase tracking-[0.25em] transition-colors"
            >
              Register Now <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
        <div className="lg:col-span-5 bg-[#ffefd1] relative min-h-[50vh] img-zoom">
          <img
            src={img}
            alt="Makeup artist at work"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};
